// import React from 'react';

// export default function SmartPagination({
//   page,
//   setPageNumber,
//   total_count = 0,
//   LIMIT = 10,
//   pages = Math.ceil(total_count / LIMIT),
// }) {
//   const newLimit =
//     new URLSearchParams(window.location.search).get('limit') || LIMIT;

//   return (
//     <>
//       <div className='mt-4 d-flex justify-content-between align-items-center'>
//         <div className='text-muted' style={{ fontSize: '12px' }}>
//           Showing {(page - 1) * newLimit + 1} to{' '}
//           {Math.min(page * newLimit, total_count)} of {total_count} entries
//         </div>

//         <nav aria-label='Activities pagination'>
//           <ul className='pagination pagination-sm mb-0'>
//             <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
//               <button
//                 className='page-link'
//                 onClick={() => setPageNumber(page - 1)}
//                 disabled={page <= 1}
//                 style={{ fontSize: '12px', padding: '6px 12px' }}
//               >
//                 <i
//                   className='fa fa-chevron-left me-1'
//                   style={{ fontSize: '10px' }}
//                 ></i>
//                 Previous
//               </button>
//             </li>

//             {page > 3 && (
//               <>
//                 <li className='page-item'>
//                   <button
//                     className='page-link'
//                     onClick={() => setPageNumber(1)}
//                     style={{
//                       fontSize: '12px',
//                       padding: '6px 10px',
//                       minWidth: '36px',
//                     }}
//                   >
//                     1
//                   </button>
//                 </li>
//                 {page > 4 && (
//                   <li className='page-item disabled'>
//                     <span
//                       className='page-link'
//                       style={{ fontSize: '12px', padding: '6px 10px' }}
//                     >
//                       ...
//                     </span>
//                   </li>
//                 )}
//               </>
//             )}

//             {Array.from({ length: Math.min(5, pages) }, (_, i) => {
//               let pageNum;
//               if (pages <= 5) {
//                 pageNum = i + 1;
//               } else if (page <= 3) {
//                 pageNum = i + 1;
//               } else if (page >= pages - 2) {
//                 pageNum = pages - 4 + i;
//               } else {
//                 pageNum = page - 2 + i;
//               }

//               if (pageNum < 1 || pageNum > pages) return null;

//               return (
//                 <li
//                   key={pageNum}
//                   className={`page-item ${page === pageNum ? 'active' : ''}`}
//                 >
//                   <button
//                     className='page-link'
//                     onClick={() => setPageNumber(pageNum)}
//                     style={{
//                       fontSize: '12px',
//                       padding: '6px 10px',
//                       minWidth: '36px',
//                       fontWeight: page === pageNum ? '600' : '400',
//                     }}
//                   >
//                     {pageNum}
//                   </button>
//                 </li>
//               );
//             })}

//             {page < pages - 2 && (
//               <>
//                 {page < pages - 3 && (
//                   <li className='page-item disabled'>
//                     <span
//                       className='page-link'
//                       style={{ fontSize: '12px', padding: '6px 10px' }}
//                     >
//                       ...
//                     </span>
//                   </li>
//                 )}
//                 <li className='page-item'>
//                   <button
//                     className='page-link'
//                     onClick={() => setPageNumber(pages)}
//                     style={{
//                       fontSize: '12px',
//                       padding: '6px 10px',
//                       minWidth: '36px',
//                     }}
//                   >
//                     {pages}
//                   </button>
//                 </li>
//               </>
//             )}

//             <li className={`page-item ${page >= pages ? 'disabled' : ''}`}>
//               <button
//                 className='page-link'
//                 onClick={() => setPageNumber(page + 1)}
//                 disabled={page >= pages}
//                 style={{ fontSize: '12px', padding: '6px 12px' }}
//               >
//                 Next
//                 <i
//                   className='fa fa-chevron-right ms-1'
//                   style={{ fontSize: '10px' }}
//                 ></i>
//               </button>
//             </li>
//           </ul>
//         </nav>

//         <div className='d-flex align-items-center gap-2'>
//           <span className='text-muted' style={{ fontSize: '12px' }}>
//             Go to:
//           </span>
//           <input
//             type='number'
//             className='form-control form-control-sm'
//             style={{
//               width: '60px',
//               fontSize: '12px',
//               textAlign: 'center',
//             }}
//             min='1'
//             max={pages}
//             placeholder={page}
//             onKeyPress={(e) => {
//               if (e.key === 'Enter') {
//                 const newPage = Number.parseInt(e.target.value);
//                 if (newPage >= 1 && newPage <= pages) {
//                   setPageNumber(newPage);
//                   e.target.value = '';
//                 }
//               }
//             }}
//           />
//           <span className='text-muted' style={{ fontSize: '11px' }}>
//             of {pages}
//           </span>
//         </div>
//       </div>
//     </>
//   );
// }

'use client';

import React from 'react';

export default function SmartPagination({
  page,
  setPageNumber,
  total_count = 0,
  LIMIT = 10,
  pages = Math.ceil(total_count / LIMIT),
}) {
  const newLimit =
    new URLSearchParams(window.location.search).get('limit') || LIMIT;

  let startPage = Math.max(1, page - 2);
  let endPage = Math.min(pages, page + 2);

  if (endPage - startPage < 4) {
    if (startPage === 1) {
      endPage = Math.min(5, pages);
    } else if (endPage === pages) {
      startPage = Math.max(pages - 4, 1);
    }
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const lastPageInLoop = pageNumbers[pageNumbers.length - 1];

  return (
    <div className='mt-4 d-flex justify-content-between align-items-center'>
      {/* Showing Info */}
      <div className='text-muted' style={{ fontSize: '12px' }}>
        Showing {(page - 1) * newLimit + 1} to{' '}
        {Math.min(page * newLimit, total_count)} of {total_count} entries
      </div>

      {/* Pagination UI */}
      <nav aria-label='Activities pagination'>
        <ul className='pagination pagination-sm mb-0'>
          {/* Previous */}
          <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
            <button
              className='page-link'
              onClick={() => setPageNumber(page - 1)}
              disabled={page <= 1}
              style={{ fontSize: '12px', padding: '6px 12px' }}
            >
              <i
                className='fa fa-chevron-left me-1'
                style={{ fontSize: '10px' }}
              ></i>
              Previous
            </button>
          </li>

          {/* First Page Button + Ellipsis */}
          {startPage > 1 && (
            <>
              <li className='page-item'>
                <button
                  className='page-link'
                  onClick={() => setPageNumber(1)}
                  style={{
                    fontSize: '12px',
                    padding: '6px 10px',
                    minWidth: '36px',
                  }}
                >
                  1
                </button>
              </li>
              {startPage > 2 && (
                <li className='page-item disabled'>
                  <span
                    className='page-link'
                    style={{ fontSize: '12px', padding: '6px 10px' }}
                  >
                    ...
                  </span>
                </li>
              )}
            </>
          )}

          {/* Main Loop */}
          {pageNumbers.map((pageNum) => (
            <li
              key={pageNum}
              className={`page-item ${page === pageNum ? 'active' : ''}`}
            >
              <button
                className='page-link'
                onClick={() => setPageNumber(pageNum)}
                style={{
                  fontSize: '12px',
                  padding: '6px 10px',
                  minWidth: '36px',
                  fontWeight: page === pageNum ? '600' : '400',
                }}
              >
                {pageNum}
              </button>
            </li>
          ))}

          {/* Ellipsis + Last Page Button */}
          {lastPageInLoop < pages && (
            <>
              {lastPageInLoop < pages - 1 && (
                <li className='page-item disabled'>
                  <span
                    className='page-link'
                    style={{ fontSize: '12px', padding: '6px 10px' }}
                  >
                    ...
                  </span>
                </li>
              )}
              <li className='page-item'>
                <button
                  className='page-link'
                  onClick={() => setPageNumber(pages)}
                  style={{
                    fontSize: '12px',
                    padding: '6px 10px',
                    minWidth: '36px',
                  }}
                >
                  {pages}
                </button>
              </li>
            </>
          )}

          {/* Next */}
          <li className={`page-item ${page >= pages ? 'disabled' : ''}`}>
            <button
              className='page-link'
              onClick={() => setPageNumber(page + 1)}
              disabled={page >= pages}
              style={{ fontSize: '12px', padding: '6px 12px' }}
            >
              Next
              <i
                className='fa fa-chevron-right ms-1'
                style={{ fontSize: '10px' }}
              ></i>
            </button>
          </li>
        </ul>
      </nav>

      {/* Go to Page */}
      <div className='d-flex align-items-center gap-2'>
        <span className='text-muted' style={{ fontSize: '12px' }}>
          Go to:
        </span>
        <input
          type='number'
          className='form-control form-control-sm'
          style={{ width: '60px', fontSize: '12px', textAlign: 'center' }}
          min='1'
          max={pages}
          placeholder={page}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              const newPage = Number.parseInt(e.target.value);
              if (newPage >= 1 && newPage <= pages) {
                setPageNumber(newPage);
                e.target.value = '';
              }
            }
          }}
        />
        <span className='text-muted' style={{ fontSize: '11px' }}>
          of {pages}
        </span>
      </div>
    </div>
  );
}
